const responsiveObj = {
  default: {
    breakpoint: { max: 995, min: 340 },
    items: 1,
  },
};

const FEATURES_LIST_BREAKPOINT = 576;

export { responsiveObj, FEATURES_LIST_BREAKPOINT };
